"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineChatContainer = exports.suggestPreferencesFile = exports.differentOrigin = exports.getArchiveUrl = exports.uniqueNodes = exports.newThing = void 0;
var rdflib_1 = require("rdflib");
function newThing(doc) {
    return (0, rdflib_1.sym)(doc.uri + "#" + "id" + ("" + Date.now()));
}
exports.newThing = newThing;
function uniqueNodes(arr) {
    var uris = arr.map(function (x) { return x.uri; });
    var set = new Set(uris);
    var uris2 = Array.from(set);
    var arr2 = uris2.map(function (u) { return new rdflib_1.NamedNode(u); });
    return arr2; // Array.from(new Set(arr.map(x => x.uri))).map(u => sym(u))
}
exports.uniqueNodes = uniqueNodes;
function getArchiveUrl(baseUrl, date) {
    var year = date.getUTCFullYear();
    var month = ('0' + (date.getUTCMonth() + 1)).slice(-2);
    var day = ('0' + (date.getUTCDate())).slice(-2);
    var parts = baseUrl.split('/');
    var filename = parts[parts.length - 1];
    return new URL("./archive/".concat(year, "/").concat(month, "/").concat(day, "/").concat(filename), baseUrl).toString();
}
exports.getArchiveUrl = getArchiveUrl;
function differentOrigin(doc) {
    if (!doc) {
        return true;
    }
    return ("".concat(window.location.origin, "/") !== new URL(doc.value).origin);
}
exports.differentOrigin = differentOrigin;
function suggestPreferencesFile(me) {
    var stripped = me.uri.replace('/profile/', '/').replace('/public/', '/');
    // const stripped = me.uri.replace(\/[p|P]rofile/\g, '/').replace(\/[p|P]ublic/\g, '/')
    var folderURI = stripped.split('/').slice(0, -1).join('/') + '/Settings/';
    var fileURI = folderURI + 'Preferences.ttl';
    return (0, rdflib_1.sym)(fileURI);
}
exports.suggestPreferencesFile = suggestPreferencesFile;
function determineChatContainer(invitee, podRoot) {
    // Create chat
    // See https://gitter.im/solid/chat-app?at=5f3c800f855be416a23ae74a
    var chatContainerStr = new URL("IndividualChats/".concat(new URL(invitee.value).host, "/"), podRoot.value).toString();
    return new rdflib_1.NamedNode(chatContainerStr);
}
exports.determineChatContainer = determineChatContainer;
//# sourceMappingURL=utils.js.map